export function OutlineEstatusCampanaIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9218 0.914571L10.6672 8.55363C10.5442 8.77215 10.6891 9.0453 10.935 9.05441C12.3927 9.11359 16.4806 9.4004 18.8868 10.8435L20.9812 12.0955C21.1348 12.1865 21.3324 12.1319 21.4246 11.9725L23.159 8.8632C23.2468 8.70387 23.1941 8.499 23.0405 8.4034L20.946 7.15147C18.5399 5.71289 16.2567 2.18471 15.4751 0.905466C15.3434 0.691499 15.0448 0.700604 14.9218 0.919123V0.914571Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M19.754 11.4863L19.2122 12.4929L18.6704 13.4995"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 18H3.4608L4.44426 21.0034L7.38851 12.75L9.35542 23.25L12.2997 15.0026L13.2831 18H15.2439"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
